import { createContext } from "react";
import type { Status } from "types/Status";

const GroupsStatusContext = createContext<Status | undefined>(undefined);
GroupsStatusContext.displayName = "GroupsStatusContext";

export default GroupsStatusContext;
